import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithErrorHandling from '../../../api/apiConfig';

export const apiChangePasswordSlice = createApi({
  reducerPath: 'changePasswordApi', // name reducer of API slice
  baseQuery: baseQueryWithErrorHandling,
  endpoints: (builder) => ({
    changePassword: builder.mutation({
      query: (data) => ({
        url: `/${process.env.REACT_APP_API_VERSION}/reset-password`,
        method: 'POST',
        body: data,
      }),
    }),

  }),
});

export const { useChangePasswordMutation } = apiChangePasswordSlice;